export default __webpack_public_path__ + "static/media/ll.8c77ae95.jfif";